
import HeaderTitulo from '../../components/header-titulo'
// import {PROPOSTA_MOCK} from "../../data/propostaMock";
import AditivoEnviarRequest from "../../classes/AditivoEnviarRequest";
import AditivoService from "../../services/aditivoService";
import { saveAs } from 'file-saver';

export default {
  name: 'aditivo',
  props: ['propostaResponse'],
  components: { HeaderTitulo },
  data () {
    return {
      arquivo: null,
      proposta: null,
      aditivoEnviarRequest: new AditivoEnviarRequest(),
      isLoadingUpload: false
    }
  },
  watch: {
    'arquivo' () {
      this.CheckFileSize()
    }
  },
  methods: {
    init () {
      let proposta = this.propostaResponse
      if (!proposta || proposta === undefined) {
        this.$router.push({ name: 'consulta' })
        return
      }
      this.proposta = this.propostaResponse;
    },
    uploadArquivo () {
      this.CheckFileSize()
      this.aditivoEnviarRequest.idPropostaRepactuacao = this.proposta.idPropostaRepactuacao
      this.toBase64(this.arquivo).then(res => {
        this.aditivoEnviarRequest.base64 = res
        this.aditivoEnviarRequest.tipo = this.getTipoArquivo(this.arquivo)
        this.sendFileToServer()
      })
    },
    sendFileToServer () {
      this.isLoadingUpload = true
      this.CheckFileSize()
      AditivoService.uploadArquivo(this.aditivoEnviarRequest, this.proposta.chave)
        .then(res => {
          if (res.data.code === 99) {
            this.$b.nError(`${res.data.message}`)
            return
          }
          this.$router.push({ name: 'aditivoSucesso', params: { mensagemResponse: res.data.message } })
        })
        .catch(err => {
          this.$b.nError(`${err.data.message}`)
        })
        .finally(() => this.isLoadingUpload = false)
    },
    /**
     * Converte File para Base64
     * @param {File} file
     * @returns {Promise<String>}
     */
    toBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    /**
     *
     * @param {File} file
     */
    getTipoArquivo (file) {
      return file.type === 'application/pdf' ? 'PDF' : 'JPG'
    },
    gerarAditivo () {
      this.$q.loading.show()
      AditivoService.gerarAditivo(this.proposta.idPropostaRepactuacao, this.proposta.chave)
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/pdf;charset=utf-8" })
          saveAs(blob, `proposta-repactuacao-${this.proposta.idPropostaRepactuacao}.pdf`)
          return
        })
        .catch((err) => {
          this.$b.nError(`${err.data.message}`);
        })
        .finally(() => {
          this.$q.loading.hide()
        });
    },
    CheckFileSize () {
      if (this.arquivo !== null && this.arquivo.size > 5242880) {
        this.$b.nError('Arquivo maior que 5MB')
        return this.arquivo = null
      }
    },
    ab2str (buf) {
      return String.fromCharCode.apply(null, new Uint16Array(buf));
    }
  },
  beforeMount () {
    this.init()
  }
}
